import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

import { DateUtil } from '../../common-app/util/date-util';
import { LocalStorageService } from '../../common-app/service/local-storage.service';
import { SharedService } from '../../common-app/service/shared.service';

import { Constants } from '../../constants/constants';
import { Kvaw0400Service } from '../../service/kvaw0400.service';
import { Kvaw0400Vo, StoreModel, WeekModel } from '../../service/kvaw0400.vo';
import { StoreViewModel, WeekViewModel } from './kvap0300.view-model';

@Component({
  templateUrl: './kvap0300.component.html',
  providers: [Kvaw0400Service],
})
export class Kvap0300Component implements OnInit {

  private sysdate: string;
  public weeks: WeekViewModel[] = [];
  public stores: StoreViewModel[] = [];

  public storesForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private localStorageService: LocalStorageService,
    private sharedService: SharedService,
    private kvaw0400Service: Kvaw0400Service,
    private router: Router,
  ) { }

  /**
   * 初期処理
   */
  ngOnInit() {

    const selectedWeek = this.sharedService.get<string>(Constants.SHARED_DATA_KEY_SELECTED_WEEK) || '';

    // フォームを初期化する
    this.storesForm = this.formBuilder.group({
      searchWeek: this.formBuilder.control(selectedWeek)
    });

    this.searchStoresObservable(selectedWeek).subscribe(() => {
      // 初期表示がない場合
      if (this.storesForm.controls.searchWeek.value === '' && this.weeks.length !== 0) {
        this.storesForm.controls.searchWeek.setValue(this.weeks[0].startDateFull);
        this.sharedService.set(Constants.SHARED_DATA_KEY_SELECTED_WEEK, this.weeks[0].startDateFull);
      } else {
        this.sharedService.set(Constants.SHARED_DATA_KEY_SELECTED_WEEK, this.storesForm.controls.searchWeek.value);
      }
    });
  }

  /**
   * 担当店一覧を検索する
   */
  searchStores(): void {
    this.sharedService.set(Constants.SHARED_DATA_KEY_SELECTED_WEEK, this.storesForm.controls.searchWeek.value);
    this.searchStoresObservable(this.storesForm.controls.searchWeek.value).subscribe();
  }

  /**
   * 担当店一覧を検索する
   *
   * @param startDate 検索対象週（YYYYMMDD形式）の開始日
   */
  searchStoresObservable(startDate: string = ''): Observable<Kvaw0400Vo> {

    let endDate = '';
    if (startDate) {
      const date = DateUtil.parseYYYYMMDD(startDate);
      date.setDate(date.getDate() + 6);
      endDate = DateUtil.formatYYYYMMDD(date);
    }

    return this.kvaw0400Service.searchStores(startDate, endDate).map(storeList => {

      // 表示用に値を変換
      this.sysdate = storeList.sysdate;
      this.weeks = storeList.selectableWeeks
        .sort((week1, week2) => week1.displayOrder - week2.displayOrder)
        .map(week => <WeekViewModel>{
          startDate: DateUtil.formatMMDD_SLASH(week.startDate),
          endDate: DateUtil.formatMMDD_SLASH(week.endDate),
          startDateFull: week.startDate,
        });

      this.stores = storeList.stores.map(store => {

        return <StoreViewModel>{
          storeCode: store.storeCode,
          storeName: store.storeName,
          deliveryDate: store.deliveryDate,
          saved: this.localStorageService.load(Constants.LOCAL_SAVE_KEY_GROUP_COMPANY_CODE
            + (store.deliveryDate ? store.deliveryDate.toString() : startDate ? startDate : storeList.selectableWeeks[0].startDate)
            + store.storeCode) ? true : false,
        };
      });

      return storeList;
    });
  }

  /**
   * 日報報告画面に遷移する.
   */
  report(store: StoreViewModel) {
    this.router.navigate(['/kvap0800'], {
      queryParams: {
        storeCode: store.storeCode,
        deliveryDate: store.deliveryDate ? store.deliveryDate : this.storesForm.controls.searchWeek.value
      }
    });
  }

  /**
   * 過去日報一覧モードに遷移する
   */
  pastReport() {
    this.router.navigate(['/kvap0302/kvap0301'], { skipLocationChange: true });
  }
}



// WEBPACK FOOTER //
// ./src/app/component/kvap0300/kvap0300.component.ts